import { useAppSelector } from 'store';
import { hasPermission } from 'v2/utils/permissions';

export function useHasAnyPermission(permissions: string[]): boolean {
  const userPermissions = useAppSelector(
    (state) => state.permissions.permissions
  );

  return hasPermission(userPermissions, permissions);
}
